import React from 'react';
import { motion } from 'framer-motion';
export function HeatWaveEffect() {
  return <div className="absolute inset-0 overflow-hidden pointer-events-none z-0" data-id="element-179">
      {/* Warm gradient background base */}
      <div className="absolute inset-0 bg-gradient-to-b from-sand-50 via-sand-100 to-sand-200 opacity-50" data-id="element-180" />

      {/* Animated heat haze layers */}
      <motion.div className="absolute inset-0 opacity-30" animate={{
      background: ['linear-gradient(0deg, transparent 0%, rgba(255,255,255,0.2) 50%, transparent 100%)', 'linear-gradient(0deg, transparent 20%, rgba(255,255,255,0.2) 70%, transparent 100%)', 'linear-gradient(0deg, transparent 0%, rgba(255,255,255,0.2) 50%, transparent 100%)'],
      y: [0, -20, 0]
    }} transition={{
      duration: 8,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-181" />

      {/* Subtle shifting shapes to mimic desert mirage */}
      <motion.div className="absolute -bottom-1/2 -left-1/4 w-[150%] h-[150%] rounded-[100%] bg-terracotta-400 blur-[120px] opacity-10" animate={{
      scale: [1, 1.1, 1],
      rotate: [0, 5, 0],
      x: [0, 50, 0]
    }} transition={{
      duration: 20,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-182" />

      <motion.div className="absolute top-1/4 -right-1/4 w-[80%] h-[80%] rounded-[100%] bg-sand-300 blur-[100px] opacity-20" animate={{
      scale: [1, 1.2, 1],
      x: [0, -30, 0],
      y: [0, 30, 0]
    }} transition={{
      duration: 25,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-183" />
    </div>;
}